module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp2_3009.54bb0d37.png";